import { formatAccountType } from "@/lib/account-utils";
import { formatCurrency } from "@/lib/currency.utils";

/**
 * Custom tooltip component for the pie chart
 */
export default function CustomTooltip({ active, payload, selectedCurrency }: any) {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const data = payload[0].payload;

  return (
    <div className="bg-background border border-border rounded-lg shadow-lg p-3">
      <p className="text-sm font-semibold mb-1">{data.name}</p>
      <p className="text-sm text-muted-foreground mb-1">
        {formatAccountType(data.type)}
      </p>
      {data.bankName && (
        <p className="text-sm text-muted-foreground mb-1">{data.bankName}</p>
      )}
      <p className="text-sm text-muted-foreground mb-1">
        {data.accountNumber}
      </p>
      <p className="text-lg font-semibold">
        {formatCurrency(data.value, selectedCurrency)}
      </p>
      <p className="text-sm text-muted-foreground">
        {data.percentage.toFixed(1)}%
      </p>
    </div>
  );
}